import {ChangeDetectorRef, Component, OnInit} from '@angular/core';
import {MediaMatcher} from '@angular/cdk/layout';
import {NavigationService} from '../../services/nav/navigation.service';
import {HtmlDocumentControllerService, HtmlDocumentDto} from '@api/utisha-backend';
import { NavComponent } from '../../nav/nav.component';
import { NavMenuItem } from '../../nav/nav-menu-item';
import { VersionComponent } from '../../version/version.component';

@Component({
    selector: 'app-student-home',
    templateUrl: './student-home.component.html',
    styleUrls: ['./student-home.component.scss'],
    imports: [NavComponent, VersionComponent]
})
export class StudentHomeComponent implements OnInit {
  mobileQuery: MediaQueryList;
  nav: NavigationService;
  private mobileQueryListener: () => void;
  private addContactMenu = false;
  menuItems: NavMenuItem[];

  constructor(changeDetectorRef: ChangeDetectorRef, media: MediaMatcher, navService: NavigationService,
              private docService: HtmlDocumentControllerService) {
    this.mobileQuery = media.matchMedia('(max-width: 600px)');
    this.mobileQueryListener = () => changeDetectorRef.detectChanges();
    this.mobileQuery.addListener(this.mobileQueryListener);
    this.nav = navService;
    this.createMenuItems();
  }

  ngOnInit(): void {
    this.docService.getHtmlDocumentByType(HtmlDocumentDto.TypeEnum.Contact).subscribe(
      contactDocs => {
        this.addContactMenu = contactDocs.length > 0;
        this.createMenuItems();
      }
    ); // swallow error
  }

  createMenuItems(): void {
    const items: NavMenuItem[] = [
      {title: 'events', url: '/student/events', icon: 'calendar'},
      {title: 'articles.label', url: '/student/articles', icon: 'file-text'},
      {title: 'referral.plural', url: '/student/referrals', icon: 'gift'},
    ];
    if (this.addContactMenu) {
      items.push({title: 'contact.label', url: '/student/contact', icon: 'mail'});
    }
    this.menuItems = items;
  }

}
